import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from 'redux';
// import { reducer as clientReducer } from "./reducer/accountReducer";
import thunkMiddleware from "redux-thunk";
import accountReducer from "./reducer/accountReducer";
// import { createLogger } from "redux-logger";

const middleware = [
  thunkMiddleware,
  
];

const rootReducer = combineReducers({
  account: accountReducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middleware),
  devTools:true
});

export default store;
